// API
import { apiFetch } from '../../app/apiFetch';

// Constants
import { ERROR_EXPIRED_TOKEN } from '../../utils/constants/constants';
const baseUrl = `https://${process.env.REACT_APP_API}/api`;

// Types
type AppApiReturn = {
    token: string;
};

/**
 * @function getToken
 * Requests API token
 *
 * @return {object} User
 */
export function getToken() {
    const authToken = sessionStorage.getItem('authToken');
    const url = `${baseUrl}/login?bred_token=${authToken}`;

    return new Promise<AppApiReturn>((resolve, reject) =>
        fetch(`${url}`, {
            method: 'POST',
        })
            .then((response) => response.json())
            .then((result) => {
                resolve(result);
            })
            .catch((error) => {
                console.log(error);
                reject(ERROR_EXPIRED_TOKEN);
            }),
    );
}

/**
 * @function getGameMods
 * Requests avaialable game mods
 *
 * @return {array} List of game mods
 */
export function getGameMods() {
    const endpoint = `/v2/game_mods/`;

    return apiFetch('GET', endpoint);
}
